import React from "react";

// Source
import * as ModelAlert from "../model/Alert";
import * as HelperSrc from "../HelperSrc";
import StoreAlert from "../store/Alert";

export default class ControllerAlert {
    // Variable
    private storeMain: ModelAlert.Istore;
    private storageMainData = React.useRef<ModelAlert.Idata | undefined>(undefined);

    private elementViewMain = React.useRef<HTMLElement | null>(null);

    private isRendered = React.useRef<boolean>(false);

    getStorageMain: ModelAlert.Idata | undefined;
    setStorageMain: React.Dispatch<React.SetStateAction<ModelAlert.Idata | undefined>>;

    getIsShow: boolean;
    setIsShow: React.Dispatch<React.SetStateAction<boolean>>;

    // Method
    constructor(isRendered: boolean) {
        this.storeMain = new StoreAlert();
        this.storageMainData.current = this.storeMain.storageGet();

        this.isRendered.current = isRendered;

        const [getStorageMain, setStorageMain] = React.useState<ModelAlert.Idata | undefined>(this.storageMainData.current);
        this.getStorageMain = getStorageMain;
        this.setStorageMain = setStorageMain;

        const [getIsShow, setIsShow] = React.useState<boolean>(false);
        this.getIsShow = getIsShow;
        this.setIsShow = setIsShow;
    }

    initializeHook = (): void => {
        React.useEffect(() => {
            HelperSrc.domObserver(".view_alert", () => {
                this.initializeHtmlElement();
            });

            this.handleStorage();

            HelperSrc.storageEventListener("alert", () => {
                this.handleStorage();
            });
        }, []);

        React.useEffect(() => {
            this.storageMainData.current = this.storeMain.storageGet();
        }, [this.storageMainData.current]);
    };

    show = (
        alertType: HelperSrc.Color,
        message: string,
        isAutoClose = true,
        isRedirect = false,
        isRemoveStore = true,
        callback?: () => void
    ): void => {
        this.storeMain.storageSet({
            alertType,
            message,
            isOpen: true,
            isAutoClose,
            isRedirect,
            isRemoveStore
        });

        if (isAutoClose) {
            setTimeout(() => {
                this.storeMain.storageSet({
                    alertType,
                    message,
                    isOpen: false,
                    isAutoClose,
                    isRedirect,
                    isRemoveStore
                });

                if (callback) {
                    callback();
                }

                if (isRemoveStore) {
                    this.storeMain.storageRemove();
                }
            }, HelperSrc.STATUS_TIMEOUT);
        } else {
            if (callback) {
                callback();
            }

            if (isRemoveStore) {
                this.storeMain.storageRemove();
            }
        }
    };

    private handleStorage = (): void => {
        this.storageMainData.current = this.storeMain.storageGet();
        this.setStorageMain(this.storageMainData.current);

        if (this.storageMainData.current) {
            this.setIsShow(this.storageMainData.current.isOpen);

            if (this.storageMainData.current.isRemoveStore) {
                this.storeMain.storageRemove();
            }
        }
    };

    close = (): void => {
        this.setIsShow(false);
    };

    private initializeHtmlElement = (): void => {
        if (!this.elementViewMain.current) {
            this.elementViewMain.current = document.querySelector<HTMLElement>(".view_alert");
        }
    };
}
